import React, { useState } from 'react';
import chathist from "../../assets/icon_chathist.png";
import chathistDark from "../../assets/icon_chathist_dark.png";
import trash from "../../assets/icon_trashchat.png";
import trashDark from "../../assets/icon_trashchat_dark.png";
import chatdone from "../../assets/icon_chatdone.png";
import confirm from "../../assets/icon_confirm.png";
import confirmDark from "../../assets/icon_confirm_dark.png";
import cancel from "../../assets/icon_cancel.png";
import cancelDark from "../../assets/icon_cancel_dark.png";
import { useSelector, useDispatch } from 'react-redux'
import { selectCurrentPage, setCurrPage } from '../../slices/sideBarSlice'
import { selectCurrChat, setCurrChat } from '../../slices/currChatSlice';
import { removeChat } from '../../slices/chatSlice'
import { deteleChatInDB } from '../../slices/chatThunk'
import { selectChatWithSessionId } from '../../slices/chatSlice'
import { timeString } from './chatHistoryUtils';
import EllipsisDropDown from './EllipsisDropDown';
import ChatConfigPanel from './ChatConfigPanel';
import { deleteSessionInBE } from '../../slices/openAiThunk';

const ChatHistory = React.forwardRef(({ sessionId }, ref) => {
    const dispatch = useDispatch();

    const currChat = useSelector(selectCurrChat);
    const currPage = useSelector(selectCurrentPage);
    const chat = useSelector(selectChatWithSessionId(sessionId))

    const [confirmDelete, setConfirmDelete] = useState(false);
    const [isChatConfigVisible, setIsChatConfigVisible] = useState(false);

    // Sets this chat to be deleted from SideBar.js
    const deleteChat = () => {
        // update UI
        dispatch(removeChat(sessionId))
        if (sessionId === currChat.sessionId) {
            dispatch(setCurrPage('welcome'));
        }
        setConfirmDelete(false);

        // update DB
        dispatch(deteleChatInDB(sessionId))
        dispatch(deleteSessionInBE(sessionId))
    }

    // Determines if the chat icon should be the in progress icon or the completed icon
    const determineChatIcon = () => {
        if (chat.stage === 'complete') {
            return chatdone;
        } else if (confirmDelete.current) {
            return trash;
        } else {
            return chathist;
        }
    }
    const determineChatIconDark = () => {
        if (chat.stage === 'complete') {
            return chatdone;
        } else if (confirmDelete.current) {
            return trashDark;
        } else {
            return chathistDark;
        }
    }

    // Changes homepage to display this chat
    const setChat = async () => {
        dispatch(setCurrChat(chat))
        if (currPage !== 'home') {
            dispatch(setCurrPage('home'));
        }
    }

    // Determines if this chat is currently open
    const onChat = sessionId === currChat.sessionId && currPage === 'home';

    return (
        <div ref={ref} className={`group grid grid-cols-10 items-center justify-end hover:bg-[#1e1e1e] rounded-lg ${onChat ? 'bg-[#232222] shadow-lg border-2 border-[#0c496b]' : 'bg-transparent'}`}>
            <button onClick={() => setChat()} className='col-span-8 font-normal text-base leading-5 text-white font-calibri py-2'>
                <div className="flex items-center">
                <img className={`ml-7 w-4 h-4 block`} src={determineChatIcon()} alt="Chat Icon" />
                <div className="flex flex-col items-start pl-2">
                    <span className="whitespace-nowrap">{chat.sessionName}</span>
                    <span className="text-xs text-gray-500 whitespace-nowrap">{timeString(chat.time)}</span>
                </div>
                </div>
            </button>

            {!confirmDelete ?
                <div className="col-start-10 col-span-1">
                    <EllipsisDropDown setConfirmDelete={setConfirmDelete} sessionId={sessionId} setIsChatConfigVisible={setIsChatConfigVisible}/>
                </div>
                :
                <div className='buttons grid grid-cols-2 col-start-9 col-span-2 h-11 z-40 bg-gradient-lg'>
                    <button onClick={() => deleteChat()} className='justify-self-center'>
                        <img className="ml-0  px-1 w-6 opacity-70 hover:opacity-100 block" src={confirm} alt="" />
                    </button>

                    <button onClick={() => { setConfirmDelete(false) }} className='justify-self-center'>
                        <img className="mr-0 px-1 w-5 opacity-70 hover:opacity-100 block" src={cancel} alt=""/>
                    </button>
                    </div>
            }

<           div>
                {isChatConfigVisible && <ChatConfigPanel setIsChatConfigVisible={setIsChatConfigVisible} sessionId={sessionId} onChat={onChat} />}
            </div>
        </div>
    )
})

export default ChatHistory;
